import ReduxQuerySync from 'redux-query-sync';
import { is } from '@utils/brandDiffsUtils';
//q=:relevance:colorFilter:Black:size:S:size:M:size:L
//q=refinementColor:Blue|size:S|size:M|size:L
export const initQuerySync = (store) => {
    ReduxQuerySync({
        store,
        params: {
            filters: {
                selector: (state) => {
                    // console.info('[LISTING][filters] selector: ', state.search.selectedFilters);
                    return state.search.selectedFilters.reduce((query, filter) => {
                        var _a;
                        return ((_a = filter.values) === null || _a === void 0 ? void 0 : _a.length) ? `${query}|${filter.id}:${filter.values.join(',')}` : query;
                    }, '');
                },
                action: (value) => {
                    // console.info('[LISTING][filters] action: ', value);
                    return { type: 'search/updateFiltersFromQuery', payload: value };
                },
                valueToString: (value) => {
                    return value ? value : '';
                },
                defaultValue: '',
            },
        },
        // Initially set the store's state to the current location.
        initialTruth: 'location',
        replaceState: true,
    });
};
export const initSearchQuerySync = (store) => {
    ReduxQuerySync({
        store,
        params: {
            query: {
                selector: (state) => {
                    return state.search.querySearch != '' ? state.search.querySearch : undefined;
                },
                action: (value) => {
                    return { type: 'search/updateSearchFromQuery', payload: value };
                },
            },
            category: {
                selector: (state) => {
                    return state.search.filteredCategory;
                },
                action: (value) => ({ type: 'search/updateSearchCategoryFromQuery', payload: value }),
            },
            searchFilters: {
                selector: (state) => {
                    // console.info('[SEARCH][filters] selector: ', state.search.selectedFilters);
                    return state.search.selectedFilters.reduce((query, filter) => {
                        var _a;
                        return ((_a = filter.values) === null || _a === void 0 ? void 0 : _a.length) ? `${query}|${filter.id}:${filter.values.join(',')}` : query;
                    }, '');
                },
                action: (value) => {
                    console.info('[SEARCH][filters] action: ', value);
                    return { type: 'search/updateFiltersFromQuery', payload: value };
                },
                valueToString: (value) => {
                    return value ? value : '';
                },
                defaultValue: '',
            },
        },
        // Initially set the store's state to the current location.
        initialTruth: 'location',
    });
};
export const replaceSelectedFilters = (state, filterId, valueId) => {
    const filterIndex = state.selectedFilters.findIndex((filter) => {
        return filter.id === filterId;
    });
    if (filterIndex !== -1) {
        let filter = state.selectedFilters[filterIndex];
        if (filter.values.includes(valueId)) {
            filter.values = filter.values.filter((value) => {
                return value !== valueId;
            });
            //remove filter value
        }
        else {
            //replace selected filters with
            filter.values = [valueId];
        }
        state.selectedFilters[filterIndex] = filter;
    }
    else {
        //missing filter (add it)
        updatedSelectedFilters(state, filterId, valueId);
    }
};
export const updatedSelectedFilters = (state, filterId, valueId) => {
    const filterIndex = state.selectedFilters.findIndex((filter) => {
        return filter.id === filterId;
    });
    if (filterIndex !== -1) {
        let filter = state.selectedFilters[filterIndex];
        console.log('adding existing', filter.id, [valueId]);
        if (filter.values.includes(valueId)) {
            filter.values = filter.values.filter((value) => {
                return value !== valueId;
            });
            //remove filter value
        }
        else {
            filter.values.push(valueId);
            //add filter value
        }
        state.selectedFilters[filterIndex] = filter;
    }
    else {
        console.log('adding missing', filterId, [valueId]);
        state.selectedFilters.push({
            id: filterId,
            values: [valueId],
        });
    }
};
export const pageSize = (fallback, options) => {
    var _a, _b;
    if (is('ST')) {
        const start = options.start || 0;
        if (options.tier === 'tier3') {
            let pageSize = start == 0 ? 16 : 20;
            const gridsInCurrentPage = (_a = options.gridIndexes) === null || _a === void 0 ? void 0 : _a.filter((index) => index >= start && index < start + pageSize);
            pageSize += ((gridsInCurrentPage === null || gridsInCurrentPage === void 0 ? void 0 : gridsInCurrentPage.length) || 0) * 9;
            const crossCategoryLinksInCurrentPage = (_b = options.crossCategoryLinksIndexes) === null || _b === void 0 ? void 0 : _b.filter((index) => index >= start && index < start + pageSize);
            pageSize -= ((crossCategoryLinksInCurrentPage === null || crossCategoryLinksInCurrentPage === void 0 ? void 0 : crossCategoryLinksInCurrentPage.length) || 0) * 2;
            return pageSize;
        }
        else {
            //pagination - 20 per page SEO request
            if (start > 0)
                return 20;
            //tier 1 first load display 25 (16 items standard + 9 editorial tiles) items
            if (options.tier === 'tier1')
                return 25;
            //tier 2
            return 16;
        }
    }
    return fallback;
};
